import script from "./PetSelectorConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./PetSelectorConfig.vue?vue&type=script&setup=true&lang=js"

import "./PetSelectorConfig.vue?vue&type=style&index=0&id=e1ecc0de&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ecc0de"]])

export default __exports__